import { UUID } from '@control-front-end/common/constants/regExp';

export default {
  // Генерация udid
  udid() {
    return Date.now().toString() + Math.floor(Math.random() * 10000 + 1); // NOSONAR
  },

  isUuid(str) {
    const r = new RegExp(UUID, 'i');
    return r.test(str);
  },

  // Генерация rid
  createRid() {
    const min = 1;
    const max = 100000;
    const time = new Date().getTime();
    const random = Math.floor((Math.random() * (max - min) + min) * 10000); // NOSONAR
    return `${time}_${random}`;
  },

  // Уникальный id для узла
  guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000) // NOSONAR
        .toString(16)
        .substring(1);
    }

    return `tmp_${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
  },

  getRandomPastelColor() {
    function randomChannel() {
      return (Math.round(Math.random() * 127) + 127).toString(16); // NOSONAR
    }
    const r = randomChannel();
    const g = randomChannel();
    const b = randomChannel();
    return `#${r}${g}${b}`;
  },
};
